import styled from 'styled-components'

const Logo = styled.img`
  max-width:  175px;
  margin: 0 auto;
  margin-top: 1.2em;
`

export default Logo
